var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DetailsListItemLocationChip',{attrs:{"code":_vm.code,"short-display-name":_vm.name,"icon-url":_vm.iconUrl,"name":_vm.name,"theme":_vm.theme,"location-type":"water"},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }